<div class="fs-2" mat-dialog-title>
    Activation de votre compte
</div>
<div mat-dialog-content>
    <img src="../../../../../assets/logo/logo%20vignette%20avec%20shadow.png" />
    Bienvenue sur Lybox,<br/>
    <br/>
    Nous allons vous aider pendant toute votre formation INVEST PRENEUR à dénicher les meilleurs offres.<br/>
    <br/>
    Un abonnement de 2 mois à Lybox est inclus gratuitement dans votre programme de formation, il ne vous reste plus qu'a l'activer
    pour en profiter.
    <br/>
    <br/>
</div>
<div mat-dialog-actions class="center">
    <button type="button" (click)="onYesClick()" class="btn btn-primary w-100">
        <i class="fa fa-check" aria-hidden="true"></i> Activer mon abonnement
    </button>
</div>
